import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import "../Features/Features.css";

const Features = ({features}) => {
    return (
        <>
            <section className='features-wrp' id='features'>
               <Container>
                    <div className='features-main'>
                        <div className='features-title'>
                            <div className='sub-title'>
                                <span>{features.subtitle}</span>
                            </div>
                            <div className='section-title'>
                                <h2>{features.sectiontitle}</h2>
                            </div>
                        </div>  
                        <div className='features-section'>
                            <Row>
                                {features.items && features.items.map((item, index) => (
                                    <Col md={6} lg={6} xl={6} xxl={6}  key={index}>
                                        <div className='features-block'>
                                            <div className='features-icon'>
                                                <img src={item.icon} alt={item.alt} className='img-fluid' />
                                            </div>
                                            <div className='features-content'>
                                                <div className='features-content'>
                                                    <div className='block-title'>
                                                        <h3>{item.title}</h3>
                                                    </div>
                                                    <div className='detail'>
                                                        <p>{item.detail}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </div>
                </Container> 
            </section>
        </>
    )
}

export default Features;